import { z } from "zod";
import { asUsTreasuryBondId, asCouponPayment, asYield } from "@goodfill/domain-properties";
import { zISODateTime, zDecimal, zMoney, zBondsBenchmark } from "@goodfill/domain-properties-zod-validators";
import { applyWithOptionalToNull } from "@goodfill/map";

export const usTreasuryBondProfileSchema = z.object({
  bondIdCusip: z.string().transform(asUsTreasuryBondId),
  maturityDate: zISODateTime(),
  couponPayment: zDecimal().transform(asCouponPayment),
  outstandingAmount: zMoney(),
  usedAsBenchmark: z.union([z.null(), zBondsBenchmark]),

  // ask (customer buy)
  askYield: zDecimal().optional().nullable().transform(applyWithOptionalToNull(asYield)),

  // bid (customer sell)
  bidYield: zDecimal().optional().nullable().transform(applyWithOptionalToNull(asYield)),
});

export type UsTreasuryBondProfile = z.infer<typeof usTreasuryBondProfileSchema>;
